/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Familylanguageisgerman3Inputs */



/**

* @param {_Field_Familylanguageisgerman3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_familylanguageisgerman3 = /** @type {((inputs?: _Field_Familylanguageisgerman3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Familylanguageisgerman3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Sprache zu Hause")
});
export { _field_familylanguageisgerman3 as "_field_familyLanguageIsGerman" }